import { useState } from 'react'

export default function SearchHistory({ searches, loading, onSelectSearch, onBuyMore }) {
  const [isExpanded, setIsExpanded] = useState(false)

  if (!searches || searches.length === 0) return null

  return (
    <div className="history-section">
      <div className="history-header">
        <h3>Historique des recherches</h3>
        <button className="toggle-history-btn" onClick={() => setIsExpanded(!isExpanded)} type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }}>
            <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
      {isExpanded && (
        <div className="history-content">
          {loading && (
            <div className="history-loading">
              <p>Chargement...</p>
            </div>
          )}
          {!loading && (
            <div className="history-list">
              {searches.map((search) => {
                const alreadyBought = search.enrichedCount || 0
                const totalAvailable = search.totalResults || 0
                const remaining = totalAvailable - alreadyBought
                const canBuyMore = remaining > 0

                return (
                  <div key={search.id} className="history-item" onClick={() => onSelectSearch?.(search)}>
                    <div className="history-item-header">
                      <div className="history-item-query">{search.query}</div>
                      <div className="history-item-date">{new Date(search.createdAt).toLocaleDateString('fr-FR')}</div>
                    </div>
                    <div className="history-item-stats">
                      <div className="history-stat">
                        <span className="history-stat-label">Résultats:</span>
                        <span className="history-stat-value">{totalAvailable.toLocaleString('fr-FR')}</span>
                      </div>
                      <div className="history-stat">
                        <span className="history-stat-label">Achetés:</span>
                        <span className="history-stat-value">{alreadyBought.toLocaleString('fr-FR')}</span>
                      </div>
                      <div className="history-stat">
                        <span className="history-stat-label">Crédits:</span>
                        <span className="history-stat-value">{search.creditsUsed || 0}</span>
                      </div>
                      {canBuyMore && (
                        <div className="history-stat">
                          <span className="history-stat-label">Disponibles:</span>
                          <span className="history-stat-value">{remaining.toLocaleString('fr-FR')}</span>
                        </div>
                      )}
                    </div>
                    <div className="history-item-actions">
                      <span className={`history-status-badge ${alreadyBought > 0 ? 'history-status-enriched' : 'history-status-preview'}`}>
                        {alreadyBought > 0 ? 'Acheté' : 'Aperçu'}
                      </span>
                      {canBuyMore && (
                        <button
                          className="history-buy-btn"
                          onClick={(e) => {
                            e.stopPropagation()
                            onBuyMore?.(search, remaining)
                          }}
                          type="button"
                        >
                          <svg viewBox="0 0 16 16" fill="none">
                            <path d="M8 2L10 6L14 8L10 10L8 14L6 10L2 8L6 6L8 2Z" fill="currentColor" />
                          </svg>
                          Acheter {remaining.toLocaleString('fr-FR')}
                        </button>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
